import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import { FieldPath, useFormContext } from 'react-hook-form';
import FormCheckbox from '../../Common/Form/FormCheckbox';
import { DynamicFormValues } from '../DefectDetails';
import PhotoBox from '../PhotoBox';

export interface PhotoProps {
  imgUrl: string;
  name?: FieldPath<DynamicFormValues>;
  onClick?: () => void;
  onChange?: (checked: boolean) => void;
  onDelete?: () => void;
  isChecked?: boolean;
  isClicked?: boolean;
}

const PhotoItem = ({
  imgUrl,
  name,
  isChecked,
  isClicked,
  onChange,
  onClick,
  onDelete,
}: PhotoProps) => {
  const { control } = useFormContext<DynamicFormValues>() || {};

  const [checked, setChecked] = useState(false);

  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if (isClicked !== undefined) setClicked(isClicked);
  }, [isClicked]);

  useEffect(() => {
    if (isChecked !== undefined) setChecked(isChecked);
  }, [isChecked]);

  const handleCheck = () => {
    if (!onChange) return;

    setChecked(!checked);
    onChange(!checked);
  };

  const handleClick = () => {
    if (onClick) onClick();
  };

  const spacing = isClicked ? 2 : 1;

  return (
    <PhotoBox imgUrl={imgUrl} clicked={clicked} onClick={handleClick}>
      {!!name && !!control && (
        <FormCheckbox
          control={control}
          name={name}
          checkboxProps={{
            sx: {
              position: 'absolute',
              top: spacing,
              left: spacing,
              zIndex: 1,
              background: (theme) => theme.palette.background.default,
              borderRadius: 0,
              padding: 0,
              opacity: checked ? 'unset' : 0.85,
              ':hover': {
                background: (theme) => theme.palette.background.default,
              },
            },
            checked,
            onChange: handleCheck,
          }}
        />
      )}

      {!!onDelete && (
        <Box
          sx={{
            position: 'absolute',
            bottom: spacing,
            left: spacing,
            zIndex: 1,
          }}
        >
          <IconButton
            aria-label="delete"
            size="small"
            sx={{
              background: (theme) => theme.palette.background.default,
              borderRadius: 0,
              p: 0.5,
              opacity: 0.5,
              ':hover': {
                background: (theme) => theme.palette.background.default,
                opacity: 1,
              },
            }}
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            <DeleteIcon fontSize="inherit" />
          </IconButton>
        </Box>
      )}
    </PhotoBox>
  );
};

export default PhotoItem;
